import { render, staticRenderFns } from "./homeNavigationMobile2.vue?vue&type=template&id=8bb574fc&scoped=true"
import script from "./homeNavigationMobile2.vue?vue&type=script&lang=js"
export * from "./homeNavigationMobile2.vue?vue&type=script&lang=js"
import style0 from "./homeNavigationMobile2.vue?vue&type=style&index=0&id=8bb574fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb574fc",
  null
  
)

export default component.exports